import {Link} from "react-router-dom";
import {useState} from "react";

export function Dropdown({trigger, children}) {
    const [visible, setVisible] = useState(true);

    function handleClick() {
        setVisible(!visible);
    }

    return <>
        <span onClick={handleClick} style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
            {trigger}
            {visible ?
                <i className="fas fa-angle-down pull-right pr-20"></i>
                :
                <i className="fas fa-angle-right pull-right pr-20"></i>}
        </span>

        {visible && children}

    </>
}